import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import { Error } from '../../Marketing/Error/error';
import { formatContentfulComponentProps } from '../../../utils/globals';

export const ErrorHandler = ({ children, error }) => {
  const [errorOccurred, setErrorOccurred] = useState(false);

  const defaultWindow =
    typeof window !== 'undefined' ? window.location.pathname : '';

  useEffect(() => {
    // Initialise Sentry
    if (process.env.NODE_ENV === 'production') {
      Sentry.init({
        dsn: process.env.GATSBY_SENTRY_DSN,
        ignoreErrors: [
          // Custom ignores
          'NetworkError',
          'Network Error',
          'ResizeObserver loop limit exceeded',
          'Could not fetch instagram posts. Error status Error: Network Error',
          'Error with ipify.org request',
          // Random plugins/extensions
          'top.GLOBALS',
          // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
          'originalCreateNotification',
          'canvas.contentDocument',
          'MyApp_RemoveAllHighlights',
          'http://tt.epicplay.com',
          "Can't find variable: ZiteReader",
          'jigsaw is not defined',
          'ComboSearch is not defined',
          'http://loading.retry.widdit.com/',
          'atomicFindClose',
          // Facebook borked
          'fb_xd_fragment',
          // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
          // reduce this. (thanks @acdha)
          // See http://stackoverflow.com/questions/4113268
          'bmi_SafeAddOnload',
          'EBCallBackMessageReceived',
          // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
          'conduitPage',
          'Non-Error exception captured',
          'Non-Error promise rejection captured',
        ],
        denyUrls: [
          // Facebook flakiness
          /graph\.facebook\.com/i,
          // Facebook blocked
          /connect\.facebook\.net\/en_US\/all\.js/i,
          // Woopra flakiness
          /eatdifferent\.com\.woopra-ns\.com/i,
          /static\.woopra\.com\/js\/woopra\.js/i,
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          // Other plugins
          /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
          /webappstoolbarba\.texthelp\.com\//i,
          /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
        beforeSend(event) {
          if (
            event.exception.values[0].value !== 'Failed to fetch' ||
            event.exception.values[0].value !== 'Network Error'
          ) {
            setErrorOccurred(true);
          }

          // Send error exption to google analytics
          if (typeof ga !== 'undefined') {
            ga('send', 'exception', [event]);
          }
          return event;
        },
      });
    }
  }, []);

  useEffect(
    () => () => {
      setErrorOccurred(false);
    },
    [defaultWindow]
  );

  return errorOccurred ? (
    <Error {...formatContentfulComponentProps(error)} />
  ) : (
    children
  );
};
